import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import panzoom from 'jquery.panzoom';

Snappy.Component.ViewFromSeat = class ViewFromSeat extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-view-from-seat';
    }
   
    constructor(element) {
        super(element);
    }

    setVars() {
        this.$eventTypeSelect = this.$element.find('.fa-dropdown__select--vfs')[0];
        this.$eventTypeSelectMobile = this.$element.find('.fa-dropdown__select--vfs-mobile');
        this.$sportsBlocks = this.$element.find('.vfs-sports-blocks');
        this.$sportsBoxes = this.$element.find('.vfs-sports-boxes');
        this.$musicBlocks = this.$element.find('.vfs-music-west-blocks');
        this.$musicBoxes = this.$element.find('.vfs-music-west-boxes');
        this.$seatLocationRadio = this.$element.find('.toggle-seat-type__input');
        this.seatingLocation = 'blocks';
        this.$mapPreviews = this.$element.find('map.previews area');
        this.$mapBoxes = this.$element.find('map.boxes');
        this.$mapSportsBlocks = this.$element.find('map.previews.map-sports-blocks area');
        this.$mapMusicBlocks = this.$element.find('map.previews.map-music-west-blocks area');
        this.$selectLevelMobile = this.$element.find('#select-your-level-mobile');  
        this.$selectBlockMobile = this.$element.find('#select-your-block-mobile');
        this.$selectBoxRangeSportsMobile = this.$element.find('#select-box-range-sports-mobile');
        this.$selectBoxRangeMusicMobile = this.$element.find('#select-box-range-music-west-mobile');
        this.$selectBoxNumber = this.$element.find('#select-box-number');
        this.$closeBtn = this.$element.find('.vfs-viewport .vfs-viewport__close-btn');
        this.$backButton = this.$element.find('.cta--back');
        this.$zoomContainer = this.$element.find('.vfs-viewport__zoom-container');
    }

    addEventListeners() {
        // Desktop event listeners
        if ($(window).width() > 768) {
            this.$eventTypeSelect.addEventListener('change', this.updateDesktopViewport.bind(this));
            for (var i = 0; i < this.$seatLocationRadio.length; i++) {
                this.$seatLocationRadio[i].addEventListener('change', this.updateDesktopViewport.bind(this));
            }
            for (var i = 0; i < this.$mapPreviews.length; i++) {
                this.$mapPreviews[i].addEventListener('click', this.displayBlockView.bind(this));
            }

            for (var i = 0; i < this.$closeBtn.length; i++) {
                this.$closeBtn[i].addEventListener('click', this.closeBlockView.bind(this));
            }

            for (var i = 0; i < this.$mapBoxes.length; i++) {
                this.$mapBoxes[i].addEventListener('click', this.displayBoxView.bind(this));
            }

            for (var i = 0; i < this.$backButton.length; i++) {
                this.$backButton[i].addEventListener('click', this.backToStadiumBoxes.bind(this));
            }
        }
        // Mobile event listeners
        if ($(window).width() < 768) {
            this.$eventTypeSelectMobile[0].addEventListener('change', this.updateMobileViewport.bind(this));

            for (var i = 0; i < this.$seatLocationRadio.length; i++) {
                this.$seatLocationRadio[i].addEventListener('change', this.updateMobileViewport.bind(this));
            }

            this.$selectBoxRangeSportsMobile[0].addEventListener('change', this.displaySelectYourBoxNumbers.bind(this));
            this.$selectBoxRangeMusicMobile[0].addEventListener('change', this.displaySelectYourBoxNumbers.bind(this));
            this.$selectLevelMobile[0].addEventListener('change', this.displaySelectYourBlock.bind(this));
        } 
    }

    backToStadiumBoxes(event) {
        const eventType = this.$eventTypeSelect.value;
        const activeVfsViewport = this.$element.find('.vfs-viewport .active');
        this.$closeBtn.addClass('hidden');
        this.$zoomContainer.addClass('hidden');
        activeVfsViewport.removeClass('active');
        $('.vfs-' + eventType + '-boxes').addClass('active');
    }

    displayBlockView(event) {
        const $this = event.target;
        const vfsViewport = this.$element.find('.vfs-viewport');
        const eventType = this.$eventTypeSelect.value;
        const blockNumber = $($this).attr('alt').split(' ')[1];
        const activeVfsViewport = this.$element.find('.vfs-viewport .active');
        const blockView = activeVfsViewport.find('.viewport__block-view');
        const mapView = activeVfsViewport.find('.viewport__map-view');
        const mapViewImg = mapView.find('img');
        const imgURL = `//cdn.thefa.com/viewFromYourSeat/views/${eventType}/${blockNumber}.jpg`;
        mapViewImg.attr('src', imgURL);
        
        this.$closeBtn.removeClass('hidden');
        this.$zoomContainer.removeClass('hidden');
        blockView.fadeOut(function () {
            mapView.fadeIn();
        });
        
    }

    closeBlockView(event) {
        const activeVfsViewport = this.$element.find('.vfs-viewport .active');
        const blockView = activeVfsViewport.find('.viewport__block-view');
        const mapView = activeVfsViewport.find('.viewport__map-view');
        const mapViewImg = mapView.find('img');

        const $this = $(event.target);
        mapView.fadeOut(function () {
            blockView.fadeIn();
        });
        this.$closeBtn.addClass('hidden');
        this.$zoomContainer.addClass('hidden'); 
    }

    displayBoxView(event) {
        const $this = event.target;
        const eventType = this.$eventTypeSelect.value;
        const area = $($this).data('quadrant');
        const nextMap = $('.vfs-' + eventType + '-boxes-' + area);
        const activeVfsViewport = this.$element.find('.vfs-viewport .active');

        activeVfsViewport.removeClass('active');
        nextMap.addClass('active');
    }

    updateDesktopViewport(event) {
        const value = event.target.value;
        const vfsViewport = this.$element.find('.vfs-viewport');
        const currentView = vfsViewport.find('.active');

        if (value === 'boxes' || value === 'blocks') {
            this.seatingLocation = value;
        }


        this.$zoomContainer.addClass('hidden');
        this.$closeBtn.addClass('hidden');

        switch (value) {
            case 'boxes':
                currentView.removeClass('active');
                vfsViewport.addClass('vfs-viewport--boxes');
                this.$eventTypeSelect.value === 'sports' ? this.$sportsBoxes.addClass('active') : '';
                this.$eventTypeSelect.value === 'music-west' ? this.$musicBoxes.addClass('active') : '';
                break;
            case 'blocks':
                currentView.removeClass('active');
                vfsViewport.removeClass('vfs-viewport--boxes');
                this.$eventTypeSelect.value === 'sports' ? this.$sportsBlocks.addClass('active') : '';
                this.$eventTypeSelect.value === 'music-west' ? this.$musicBlocks.addClass('active') : '';
                break;
            case 'music-west':
                currentView.find('.viewport__block-view').css('display', 'block');
                currentView.find('.viewport__map-view').css('display', 'none');
                currentView.removeClass('active');
                this.seatingLocation === 'boxes' ? this.$musicBoxes.addClass('active') : '';
                this.seatingLocation === 'blocks' ? this.$musicBlocks.addClass('active') : '';
                break;
            case 'sports':
                currentView.find('.viewport__block-view').css('display', 'block');
                currentView.find('.viewport__map-view').css('display', 'none');
                currentView.removeClass('active');
                this.seatingLocation === 'boxes' ? this.$sportsBoxes.addClass('active') : '';
                this.seatingLocation === 'blocks' ? this.$sportsBlocks.addClass('active') : '';
                break;
            default:
                break;
        }

        if ($('.viewport__block-view').hasClass('hidden')) {
            $('.viewport__block-view').removeClass('hidden');
            $('.viewport__map-view').addClass('hidden');
        }
    }


    displaySelectYourBoxNumbers() {
        const selectVal = event.target.value;
        const eventTypeVal = this.$eventTypeSelectMobile.val();
        const boxNumbers = this.getBoxNumbers(selectVal);
        const displayImageMob = this.displayImageMob;
        this.$selectBoxNumber.prop('selectedIndex', 0);
        this.$selectBoxNumber.parents('.form-group').removeClass('hidden');

        $('html, body').animate({ scrollTop: this.$selectBoxNumber.offset().top -80}, 1000);
        $('#select-box-number option:not(:first)').remove();

        this.$selectBoxNumber.append(
            boxNumbers.map(function (value) {
                return $('<option/>', {
                    value: value,
                    text: value
                })
            })
        ).change(function () {
            displayImageMob(eventTypeVal, this.value);
        });
    }

    getBoxNumbers(selectVal) {
        const boxRangeBoxes = this.$element.find(`.${selectVal} area`);
        let boxNumbers;
        let boxNumbersArray = [];

        for (var i = 0; i < boxRangeBoxes.length; i++) {
            const box = boxRangeBoxes[i];
            if ($(box).attr('alt').length < 9) {
                boxNumbers = $(box).attr('alt').split(' ')[1];
            } else {
                boxNumbers = $(box).attr('alt');
            }

            boxNumbersArray.push(boxNumbers);
        }

        return boxNumbersArray;
    }

    displaySelectYourBlock() {
        const eventTypeVal = this.$eventTypeSelectMobile.val();
        const levelVal = this.$selectLevelMobile.val();
        const displayImageMob = this.displayImageMob;
        const blockNumbers = this.getAllBlockNumbers(eventTypeVal, levelVal);

        if ($('.viewport__block-view').hasClass('hidden')) {
            $('.viewport__block-view').removeClass('hidden');
            $('.viewport__map-view').addClass('hidden');
        }

        this.$selectBlockMobile.parents('.fa-dropdown--mobile')
            .removeClass('hidden')
            .addClass('active');
        $('html, body').animate({ scrollTop: this.$selectBlockMobile.offset().top - 80 }, 1000);
        this.$selectBlockMobile.prop('selectedIndex', 0);
        $('#select-your-block-mobile option:not(:first)').remove();
        this.$selectBlockMobile.append(
            blockNumbers.map(function (value) {
                return $('<option/>', {
                    value: value,
                    text: value
                })
            })
        ).change(function () {
            displayImageMob(eventTypeVal, this.value);
        });
    }

    displayImageMob(eventType, blockNumber) {
        const imgURL = `//cdn.thefa.com/viewFromYourSeat/views/${eventType}/${blockNumber}.jpg`;
        $('.vfs-viewport__zoom-container').removeClass('hidden');

        $('.viewport__map-view img').attr('src', imgURL);
        $('.viewport__block-view').fadeOut("slow", function () {
            $('.viewport__map-view').fadeIn();
        });
    }

    getAllBlockNumbers(eventType, level) {
        let blockNumbers;
        let blockNumbersArray = [];
        let finalBlockNumbers = [];

        if (eventType === 'sports') {
            for (var i = 0; i < this.$mapSportsBlocks.length; i++) {
                const area = this.$mapSportsBlocks[i];
                blockNumbers = $(area).attr('alt').split(' ')[1];
                blockNumbersArray.push(blockNumbers);
            }
        } else {
            for (var i = 0; i < this.$mapMusicBlocks.length; i++) {
                const area = this.$mapMusicBlocks[i];
                blockNumbers = $(area).attr('alt').split(' ')[1];
                blockNumbersArray.push(blockNumbers);
            }
        }

        switch (level) {
            case '1':
                blockNumbersArray.forEach(function (entry) {
                    if (entry.match(/^1/)) {
                        finalBlockNumbers.push(entry);
                    }
                });
                break;
            case '2':
                blockNumbersArray.forEach(function (entry) {
                    if (entry.match(/^2/)) {
                        finalBlockNumbers.push(entry);
                    }
                });
                break;
            case '5':
                blockNumbersArray.forEach(function (entry) {
                    if (entry.match(/^5/)) {
                        finalBlockNumbers.push(entry);
                    }
                });
                break;
            default:
                break;
        }
        return finalBlockNumbers;
    }

    updateMobileViewport(event) {
        const value = event.target.value;
        const vfsViewport = this.$element.find('.vfs-viewport');
        const currentView = vfsViewport.find('.active');
        const eventTypeVal = this.$eventTypeSelectMobile.val();

        if (value === 'boxes' || value === 'blocks') {
            this.seatingLocation = value;
        }

        switch (value) {
            case 'boxes':
                currentView.removeClass('active');
                this.$selectLevelMobile.parents('.form-group').addClass('hidden');
                this.$selectBlockMobile.parents('.form-group').addClass('hidden');

                if (this.$eventTypeSelectMobile[0].value === 'sports') {
                    this.$sportsBoxes.addClass('active');
                    this.$selectBoxRangeMusicMobile.parents('.form-group').addClass('hidden');
                    this.$selectBoxRangeSportsMobile.parents('.form-group').removeClass('hidden');
                }

                if (this.$eventTypeSelectMobile[0].value === 'music-west') {
                    this.$musicBoxes.addClass('active');
                    this.$selectBoxRangeSportsMobile.parents('.form-group').addClass('hidden');
                    this.$selectBoxRangeMusicMobile.parents('.form-group').removeClass('hidden');
                }
                break;
            case 'blocks':
                currentView.removeClass('active');
                this.$selectBoxRangeSportsMobile.parents('.form-group').addClass('hidden');
                this.$selectBoxRangeMusicMobile.parents('.form-group').addClass('hidden');
                this.$selectBoxNumber.parents('.form-group').addClass('hidden');
           
                if (this.$eventTypeSelectMobile[0].value === 'sports') {
                    this.$sportsBlocks.addClass('active');
                }

                if (this.$eventTypeSelectMobile[0].value === 'music-west') {
                    this.$musicBlocks.addClass('active')
                }

                this.$selectLevelMobile.parents('.form-group').removeClass('hidden');
                this.$selectBlockMobile.parents('.form-group').removeClass('hidden');
                break;
            case 'music-west':
                currentView.removeClass('active');
                if (this.seatingLocation === 'boxes') {
                    this.$musicBoxes.addClass('active');
                    this.$selectBoxRangeSportsMobile.parents('.form-group').addClass('hidden');
                    this.$selectBoxRangeMusicMobile.parents('.form-group').removeClass('hidden');
                }

                if (this.seatingLocation === 'blocks') {
                    this.$musicBlocks.addClass('active');
                    this.$selectBoxRangeMusicMobile.parents('.form-group').addClass('hidden');
                }
                break;
            case 'sports':
                currentView.removeClass('active');
                if (this.seatingLocation === 'boxes') {
                    this.$sportsBoxes.addClass('active');
                    this.$selectBoxRangeMusicMobile.parents('.form-group').addClass('hidden');
                    this.$selectBoxRangeSportsMobile.parents('.form-group').removeClass('hidden');
                }

                if (this.seatingLocation === 'blocks') {
                    this.$sportsBlocks.addClass('active');
                    this.$selectBoxRangeSportsMobile.parents('.form-group').addClass('hidden');
                }
                break;
            default:
                break;
        }

        
        this.$selectLevelMobile.prop('selectedIndex', 0);
        this.$selectBlockMobile.prop('selectedIndex', 0);
        this.$selectBoxRangeSportsMobile.prop('selectedIndex', 0);
        this.$selectBoxRangeMusicMobile.prop('selectedIndex', 0);
        this.$selectBoxNumber.prop('selectedIndex', 0);
        this.$selectBlockMobile.parents('.fa-dropdown--mobile')
            .removeClass('active')
            .addClass('hidden');

        if ($('.viewport__block-view').hasClass('hidden')) {
            $('.viewport__block-view').removeClass('hidden');
            $('.viewport__map-view').addClass('hidden');
        }
    }

    render() {
        this.setVars();
        this.addEventListeners();
        // initialize panzoom on render();
        $('.viewport__map-view img').panzoom({
            disableZoom: false,
            transition: true,
            cursor: 'hand',
            contain: 'invert',
            $zoomIn: $('.vfs-viewport__zoom--in'),
            $zoomOut: $('.vfs-viewport__zoom--out'),
            $reset: $('.vfs-viewport__close-btn'),
            increment: 0.1,
            minScale: 1,
        });
    }
}



// WEBPACK FOOTER //
// ./components/ws-vfs/scripts/vfs.js